import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import DataTable from "./../Components/UserPanelDataTables/tables";

import doctor01 from "../../assets/UserPanelAssets/img/doctors/doctor-01.jpg";
import doctor02 from "../../assets/UserPanelAssets/img/doctors/doctor-02.jpg";
import doctor03 from "../../assets/UserPanelAssets/img/doctors/doctor-03.jpg";
import doctor04 from "../../assets/UserPanelAssets/img/doctors/doctor-04.jpg";
import user02 from "../../assets/UserPanelAssets/img/users/user-02.jpg";
import avatar01 from "../../assets/UserPanelAssets/img/profiles/avatar-01.jpg";
import avatar16 from "../../assets/UserPanelAssets/img/profiles/avatar-16.jpg";
import avatar15 from "../../assets/UserPanelAssets/img/profiles/avatar-15.jpg";
import avatar14 from "../../assets/UserPanelAssets/img/profiles/avatar-14.jpg";

export default function PatientAppointments() {
  const [data, setData] = useState({});

  useEffect(() => {
    setData({
      head: [
        { key: "dateTime", label: "Date & Time" },
        { key: "doctorInfo", label: "Doctor Name", subKeys: {} },
        { key: "mode", label: "Mode" },
        { key: "status", label: "Status" },
        { key: "actions", label: "Actions" },
      ],

      rows: [
        {
          dateTime: "30 Apr 2025 - 09:30 AM",
          doctorInfo: {
            doctorImage: doctor01,
            doctorName: "Dr.Alberto Ripley",
            specialty: "Cardiologist",
            doctorLink: "/patients-doctor-details",
          },
          mode: "In-person",
          status: { label: "Checked Out", type: "primary" },
          actions: [
            { label: "Edit", type: "offcanvas", target: "#edit_appointment" },
            { label: "View", type: "offcanvas", target: "#view_details" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        {
          dateTime: "15 Apr 2025 - 11:20 AM",
          doctorInfo: {
            doctorImage: doctor02,
            doctorName: "Dr.Susan Babin",
            specialty: "Orthopedic Surgeon",
            doctorLink: "/patients-doctor-details",
          },
          mode: "Online",
          status: { label: "Checked In", type: "warning" },
          actions: [
            { label: "Edit", type: "offcanvas", target: "#edit_appointment" },
            { label: "View", type: "offcanvas", target: "#view_details" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        {
          dateTime: "02 Apr 2025 - 08:15 AM",
          doctorInfo: {
            doctorImage: doctor03,
            doctorName: "Dr.Carol Lam",
            specialty: "Pediatrician",
            doctorLink: "/patients-doctor-details",
          },
          mode: "In-Person",
          status: { label: "Cancelled", type: "danger" },
          actions: [
            { label: "Edit", type: "offcanvas", target: "#edit_appointment" },
            { label: "View", type: "offcanvas", target: "#view_details" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },

        {
          dateTime: "27 Mar 2025 - 02:00 PM",
          doctorInfo: {
            doctorImage: doctor04,
            doctorName: "Dr.Marsha Noland",
            specialty: "Gynecologist",
            doctorLink: "/patients-doctor-details",
          },
          mode: "30 Apr 2025", // kept as-is (your original data)
          status: { label: "Schedule", type: "info" },
          actions: [
            { label: "Edit", type: "offcanvas", target: "#edit_appointment" },
            { label: "View", type: "offcanvas", target: "#view_details" },
            { label: "Delete", type: "modal", target: "#delete_modal" },
          ],
        },
      ],
    });
  }, []);

  return (
    <>
      <div className="content pb-0" data-aos="fade-up">
        {/* Start Page Header */}
        <div className="d-flex align-items-sm-center flex-sm-row flex-column gap-2 pb-3 mb-3 border-1 border-bottom">
          <div className="flex-grow-1">
            <h4 className="fw-bold mb-0">Appointment</h4>
          </div>

          <div className="text-end d-flex">
            {/* dropdown */}
            <div className="dropdown me-1">
              <a
                href="javascript:void(0);"
                className="btn btn-md fs-14 fw-normal border bg-white rounded text-dark d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Export <i className="ti ti-chevron-down ms-2"></i>
              </a>

              <ul className="dropdown-menu p-2">
                <li>
                  <a className="dropdown-item" href="#">
                    Download as PDF
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Download as Excel
                  </a>
                </li>
              </ul>
            </div>

            {/* switch view */}
            <div className="bg-white border shadow-sm rounded px-1 pb-0 text-center d-flex align-items-center justify-content-center">
              {/* VALID HTML → convert to Link */}
              <Link
                to="/patient-appointments"
                className="bg-light rounded p-1 d-flex align-items-center justify-content-center"
              >
                <i className="ti ti-list fs-14 text-body"></i>
              </Link>

              <Link
                to="/patient-appointment-details"
                className="bg-white rounded p-1 d-flex align-items-center justify-content-center"
              >
                <i className="ti ti-calendar-event fs-14 text-body"></i>
              </Link>
            </div>

            <a
              href="javascript:void(0);"
              className="btn btn-primary ms-2 fs-13 btn-md"
              data-bs-toggle="offcanvas"
              data-bs-target="#new_appointment"
            >
              <i className="ti ti-plus me-1"></i> New Appointment
            </a>
          </div>
        </div>
        {/* End Page Header */}

        {/* Start Filter */}
        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <div className="d-flex align-items-center gap-2">
            <div className="search-set mb-3">
              <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="table-search d-flex align-items-center mb-0">
                  <div className="search-input">
                    <a href="javascript:void(0);" className="btn-searchset"></a>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex right-content align-items-center flex-wrap mb-3">
              <div className="input-icon-start position-relative">
                <span className="input-icon-addon text-dark">
                  <i className="ti ti-calendar-event"></i>
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm bookingrange"
                />
              </div>
            </div>
          </div>

          <div className="d-flex table-dropdown mb-3 pb-1 right-content align-items-center flex-wrap row-gap-3">
            {/* FILTER DROPDOWN */}
            <div className="dropdown me-2">
              <a
                href="javascript:void(0);"
                className="bg-white border rounded btn btn-md text-dark fs-14 py-1 align-items-center d-flex fw-normal"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
              >
                <i className="ti ti-filter text-gray-5 me-1"></i> Filters
              </a>

              <div
                className="dropdown-menu dropdown-lg dropdown-menu-end filter-dropdown p-0"
                id="filter-dropdown"
              >
                <div className="d-flex align-items-center justify-content-between border-bottom filter-header">
                  <h4 className="mb-0 fw-bold">Filter</h4>
                  <div className="d-flex align-items-center">
                    <a
                      href="javascript:void(0);"
                      className="link-danger text-decoration-underline"
                    >
                      Clear All
                    </a>
                  </div>
                </div>

                <form action="#">
                  <div className="filter-body pb-0">
                    {/* Doctor */}
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="form-label mb-1">Doctor</label>
                        <a
                          href="javascript:void(0);"
                          className="link-primary mb-1"
                        >
                          Reset
                        </a>
                      </div>
                      <select className="select2" multiple="multiple">
                        <option value="m-1" selected>
                          Dr. Mick Thompson
                        </option>
                        <option value="m-2">Dr. Sarah Johnson</option>
                        <option value="m-3">Dr. Emily Carter</option>
                        <option value="m-4">Dr. David Lee</option>
                        <option value="m-5">Dr. Anna Kim</option>
                      </select>
                    </div>

                    {/* Designation */}
                    <div className="mb-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <label className="form-label">Designation</label>
                        <a
                          href="javascript:void(0);"
                          className="link-primary mb-1"
                        >
                          Reset
                        </a>
                      </div>
                      <select className="select2" multiple="multiple">
                        <option value="m-1" selected>
                          Cardiologist
                        </option>
                        <option value="m-2">Orthopedic Surgeon</option>
                        <option value="m-3">Pediatrician</option>
                        <option value="m-4">Gynecologist</option>
                      </select>
                    </div>

                    {/* Date */}
                    <div className="mb-3">
                      <label className="form-label mb-1 text-dark fs-14 fw-medium">
                        Date <span className="text-danger">*</span>
                      </label>
                      <div className="input-icon-end position-relative">
                        <input
                          type="text"
                          className="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                        />
                        <span className="input-icon-addon">
                          <i className="ti ti-calendar"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="filter-footer d-flex align-items-center justify-content-end border-top">
                    <a
                      href="javascript:void(0);"
                      className="btn btn-light btn-md me-2 fw-medium"
                      id="close-filter"
                    >
                      Close
                    </a>
                    <button
                      type="submit"
                      className="btn btn-primary btn-md fw-medium"
                    >
                      Filter
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* SORT DROPDOWN */}
            <div className="dropdown">
              <a
                href="javascript:void(0);"
                className="dropdown-toggle btn bg-white btn-md d-inline-flex align-items-center fw-normal rounded border text-dark px-2 py-1 fs-14"
                data-bs-toggle="dropdown"
              >
                <span className="me-1">Sort By :</span> Recent
              </a>

              <ul className="dropdown-menu dropdown-menu-end p-2">
                <li>
                  <a
                    href="javascript:void(0);"
                    className="dropdown-item rounded-1"
                  >
                    Recently Added
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    className="dropdown-item rounded-1"
                  >
                    Ascending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    className="dropdown-item rounded-1"
                  >
                    Descending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    className="dropdown-item rounded-1"
                  >
                    Last Month
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Filter */}

        <DataTable data={data} />
      </div>
      {/* Start Add New Appointment */}
      <div
        className="offcanvas offcanvas-offset offcanvas-end"
        tabIndex="-1"
        id="new_appointment"
      >
        <div className="offcanvas-header d-block pb-0 px-0">
          <div className="border-bottom d-flex align-items-center justify-content-between pb-3 px-3">
            <h5 className="offcanvas-title fs-18 fw-bold">New Appointment</h5>
            <button
              type="button"
              className="btn-close opacity-100"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>
        <div className="offcanvas-body pt-3">
          <form action="#">
            {/* start row*/}
            <div className="row">
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Appointment ID <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control rounded bg-light"
                      value="AP234354"
                    />
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Patient<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle form-control rounded d-flex align-items-center justify-content-between border"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="true"
                    >
                      Select
                    </a>
                    <div className="dropdown-menu shadow-lg w-100 dropdown-info">
                      <div className="mb-3">
                        <div className="input-icon-start position-relative">
                          <span className="input-icon-addon fs-12">
                            <i className="ti ti-search"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <ul className="mb-3 list-style-none">
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src="assets/img/users/user-02.jpg"
                                className="flex-shrink-0 rounded-circle"
                                alt="img"
                              />
                            </span>
                            Emily Clark
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src="assets/img/profiles/avatar-01.jpg"
                                className="flex-shrink-0 rounded-circle"
                                alt="img"
                              />
                            </span>
                            John Carter
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src="assets/img/profiles/avatar-16.jpg"
                                className="flex-shrink-0 rounded-circle"
                                alt="img"
                              />
                            </span>
                            Sophia White
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src="assets/img/profiles/avatar-15.jpg"
                                className="flex-shrink-0 rounded-circle"
                                alt="img"
                              />
                            </span>
                            Michael Johnson
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src="assets/img/profiles/avatar-14.jpg"
                                className="flex-shrink-0 rounded-circle"
                                alt="img"
                              />
                            </span>
                            Olivia Harris
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src="assets/img/profiles/avatar-01.jpg"
                                className="flex-shrink-0 rounded-circle"
                                alt="img"
                              />
                            </span>
                            David Anderson
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Appointment Type */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Appointment Type <span className="text-danger">*</span>
                  </label>
                  <div className="dropdown">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle form-control rounded d-flex align-items-center justify-content-between border"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="true"
                    >
                      Select
                    </a>
                    <div className="dropdown-menu shadow-lg w-100 dropdown-info">
                      <div className="mb-3">
                        <div className="input-icon-start position-relative">
                          <span className="input-icon-addon fs-12">
                            <i className="ti ti-search"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Select"
                          />
                        </div>
                      </div>
                      <ul className="mb-3 list-style-none">
                        <li className="list-none">
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Online
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Member
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Date and Time */}
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Date of Appointment <span className="text-danger">*</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <input
                      type="text"
                      className="form-control datetimepicker"
                      placeholder="dd/mm/yyyy"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Time <span className="text-danger">*</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <input
                      type="text"
                      className="form-control timepicker"
                      placeholder="-- : --"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-clock"></i>
                    </span>
                  </div>
                </div>
              </div>

              {/* Reason */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <div>
                    <label className="form-label mb-1 text-dark fs-14 fw-medium">
                      Appointment Reason
                    </label>
                    <textarea
                      rows="4"
                      className="form-control rounded"
                    ></textarea>
                  </div>
                </div>
              </div>

              {/* Status */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Status<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle form-control rounded d-flex align-items-center justify-content-between border"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="true"
                    >
                      Select
                    </a>
                    <div className="dropdown-menu shadow-lg w-100 dropdown-info">
                      <div className="mb-3">
                        <div className="input-icon-start position-relative">
                          <span className="input-icon-addon fs-12">
                            <i className="ti ti-search"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Select"
                          />
                        </div>
                      </div>
                      <ul className="mb-3 list-style-none">
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Checked Out
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                              defaultChecked
                            />
                            Checked In
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Cancelled
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Scheduled
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* end row*/}
          </form>
        </div>
        <div className="offcanvas-footer mb-1 mt-3 p-3 border-1 border-top">
          <div className="d-flex justify-content-end gap-2">
            <a href="javascript:void(0);" className="btn btn-light btm-md">
              Cancel
            </a>
            <button
              data-bs-dismiss="offcanvas"
              className="btn btn-primary btm-md"
            >
              Create Create Appointment
            </button>
          </div>
        </div>
      </div>
      {/* End Add New Appointment */}
      {/* Start View Details */}
      <div
        className="offcanvas offcanvas-offset offcanvas-end"
        tabIndex="-1"
        id="view_details"
      >
        <div className="offcanvas-header d-block pb-0 px-0">
          <div className="border-bottom d-flex align-items-center justify-content-between pb-3 px-3">
            <h5 className="offcanvas-title fs-18 fw-bold">
              Appointment Details{" "}
              <span className="badge badge-soft-primary border pt-1 px-2 border-primary fw-medium ms-2">
                #AP544658
              </span>
            </h5>
            <button
              type="button"
              className="btn-close opacity-100"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>

        <div className="offcanvas-body pt-0 px-0">
          <h6 className="bg-light py-2 px-3 text-dark fw-bold">
            {" "}
            When & Where{" "}
          </h6>

          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 bg-light mx-3 p-3 rounded my-3">
            <div className="d-flex align-items-center gap-2">
              <div className="avatar avatar-lg">
                <img
                  src={doctor01}
                  alt="doctor-01"
                  className="img-fluid img1 rounded-circle"
                />
              </div>
              <h6 className="fs-14 fw-semibold m-0">
                Dr. Emily Carter{" "}
                <span className="d-block fs-13 fw-normal text-body pt-1">
                  Pediatrician
                </span>
              </h6>
            </div>
            <div className="gap-1 d-flex">
              <a
                href="#"
                className="bg-white d-flex align-items-center justify-content-center p-1 border rounded"
              >
                <i className="ti ti-brand-hipchat fs-13"></i>
              </a>
              <a
                href="#"
                className="bg-white d-flex align-items-center justify-content-center p-1 border rounded"
              >
                <i className="ti ti-video fs-13"></i>
              </a>
            </div>
          </div>

          <div className="px-3 my-4">
            <p className="text-dark mb-3 fw-semibold d-flex align-items-center justify-content-between">
              Appointment On{" "}
              <span className="text-body fw-normal">
                {" "}
                Saturday, 25 Apr 2025{" "}
              </span>
            </p>
            <p className="text-dark mb-3 fw-semibold d-flex align-items-center justify-content-between">
              Time{" "}
              <span className="text-body fw-normal"> 09:00 AM - 11:00 AM </span>
            </p>
            <p className="text-dark mb-3 fw-semibold d-flex align-items-center justify-content-between">
              Location <span className="text-body fw-normal">Newyork, USA</span>
            </p>
            <p className="text-dark mb-3 fw-semibold d-flex align-items-center justify-content-between">
              Appointment Type{" "}
              <span className="text-body fw-normal"> Online Consultation </span>
            </p>
          </div>

          <h6 className="bg-light py-2 px-3 text-dark fw-bold">
            {" "}
            Appointment Details{" "}
          </h6>

          <div className="px-3 my-3">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center">
                Telehealth
                <label className="d-flex align-items-center form-switch ps-1">
                  <input
                    className="form-check-input m-0 me-2"
                    type="checkbox"
                    defaultChecked
                  />
                </label>
              </div>
              <div>
                <a
                  href="online-consulation.html"
                  className="btn-primary btn btn-sm rounded d-flex align-items-center"
                >
                  <i className="ti ti-video me-1 fs-13"></i> Start
                </a>
              </div>
            </div>

            <div className="row align-items-center">
              <div className="col-lg-6 col-md-6">
                <p className="text-dark"> Status </p>
              </div>

              <div className="col-lg-6 col-md-6">
                <div className="mb-0">
                  <div className="dropdown">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle form-control rounded d-flex align-items-center justify-content-between border"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="true"
                    >
                      Pending
                    </a>
                    <div className="dropdown-menu shadow-lg w-100 dropdown-info">
                      <div className="mb-3">
                        <div className="input-icon-start position-relative">
                          <span className="input-icon-addon fs-12">
                            <i className="ti ti-search"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Select"
                          />
                        </div>
                      </div>
                      <ul className="mb-0 list-style-none">
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Checked Out
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                              defaultChecked
                            />
                            Checked In
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Cancelled
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Scheduled
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End View Details */}
      {/* Start Edit New Appointment */}
      <div
        className="offcanvas offcanvas-offset offcanvas-end"
        tabIndex="-1"
        id="edit_appointment"
      >
        <div className="offcanvas-header d-block pb-0 px-0">
          <div className="border-bottom d-flex align-items-center justify-content-between pb-3 px-3">
            <h5 className="offcanvas-title fs-18 fw-bold"> Edit Appointment</h5>
            <button
              type="button"
              className="btn-close opacity-100"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            />
          </div>
        </div>

        <div className="offcanvas-body pt-3">
          <form action="#">
            <div className="row">
              {/* Appointment ID */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Appointment ID <span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control rounded bg-light"
                      value="AP234354"
                    />
                  </div>
                </div>
              </div>

              {/* Patient Dropdown */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Patient<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle form-control rounded d-flex align-items-center justify-content-between border"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="true"
                    >
                      Emily Clark
                    </a>
                    <div className="dropdown-menu shadow-lg w-100 dropdown-info">
                      <div className="mb-3">
                        <div className="input-icon-start position-relative">
                          <span className="input-icon-addon fs-12">
                            <i className="ti ti-search"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Search"
                          />
                        </div>
                      </div>
                      <ul className="mb-3 list-style-none">
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src={user02}
                                className="flex-shrink-0 rounded-circle"
                                alt="Emily Clark"
                              />
                            </span>
                            Emily Clark
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src={avatar01}
                                className="flex-shrink-0 rounded-circle"
                                alt="John Carter"
                              />
                            </span>
                            John Carter
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src={avatar16}
                                className="flex-shrink-0 rounded-circle"
                                alt="Sophia White"
                              />
                            </span>
                            Sophia White
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src={avatar15}
                                className="flex-shrink-0 rounded-circle"
                                alt="Michael Johnson"
                              />
                            </span>
                            Michael Johnson
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src={avatar14}
                                className="flex-shrink-0 rounded-circle"
                                alt="Olivia Harris"
                              />
                            </span>
                            Olivia Harris
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            <span className="avatar avatar-sm rounded-circle me-2">
                              <img
                                src={avatar01}
                                className="flex-shrink-0 rounded-circle"
                                alt="David Anderson"
                              />
                            </span>
                            David Anderson
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Appointment Type */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Appointment Type <span className="text-danger">*</span>
                  </label>
                  <div className="dropdown">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle form-control rounded d-flex align-items-center justify-content-between border"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="true"
                    >
                      In Person
                    </a>
                    <div className="dropdown-menu shadow-lg w-100 dropdown-info">
                      <div className="mb-3">
                        <div className="input-icon-start position-relative">
                          <span className="input-icon-addon fs-12">
                            <i className="ti ti-search"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Select"
                          />
                        </div>
                      </div>
                      <ul className="mb-0 list-style-none">
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            In Person
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Online
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              {/* Date & Time */}
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Date of Appointment <span className="text-danger">*</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <input
                      type="text"
                      className="form-control datetimepicker"
                      placeholder="20/08/2025"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-calendar"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Time <span className="text-danger">*</span>
                  </label>
                  <div className="input-icon-end position-relative">
                    <input
                      type="text"
                      className="form-control timepicker"
                      placeholder="01 : 20 : PM"
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-clock"></i>
                    </span>
                  </div>
                </div>
              </div>

              {/* Appointment Reason */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <div>
                    <label className="form-label mb-1 text-dark fs-14 fw-medium">
                      Appointment Reason
                    </label>
                    <textarea
                      rows="4"
                      className="form-control rounded"
                      defaultValue="An account of the present illness, which includes the circumstances surrounding the onset of recent health changes and the Purpose."
                    ></textarea>
                  </div>
                </div>
              </div>

              {/* Status Dropdown */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label mb-1 text-dark fs-14 fw-medium">
                    Status<span className="text-danger">*</span>
                  </label>
                  <div className="dropdown">
                    <a
                      href="javascript:void(0);"
                      className="dropdown-toggle form-control rounded d-flex align-items-center justify-content-between border"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="true"
                    >
                      Checked Out
                    </a>
                    <div className="dropdown-menu shadow-lg w-100 dropdown-info">
                      <div className="mb-3">
                        <div className="input-icon-start position-relative">
                          <span className="input-icon-addon fs-12">
                            <i className="ti ti-search"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Select"
                          />
                        </div>
                      </div>
                      <ul className="mb-3 list-style-none">
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Checked Out
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                              defaultChecked
                            />
                            Checked In
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Cancelled
                          </label>
                        </li>
                        <li>
                          <label className="dropdown-item px-2 d-flex align-items-center text-dark">
                            <input
                              className="form-check-input m-0 me-2"
                              type="checkbox"
                            />
                            Scheduled
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div className="offcanvas-footer mb-1 mt-3 p-3 border-1 border-top">
          <div className="d-flex justify-content-end gap-2">
            <a href="javascript:void(0);" className="btn btn-light btm-md">
              Cancel
            </a>
            <button
              data-bs-dismiss="offcanvas"
              className="btn btn-primary btm-md"
            >
              Create Create Appointment
            </button>
          </div>
        </div>
      </div>
      {/* End Edit New Appointment */}
    </>
  );
}
